// import React from 'react';

// const Band: React.FC = () => {
//   const items = [
//     'Mode Masculine',
//     'Qualité Premium',
//     'Style Intemporel',
//     'Élégance Moderne',
//     'Savoir-Faire',
//     'Collections Exclusives',
//   ];

//   return (
//     <div className="bg-[#111111] border-y border-[#333333] overflow-hidden h-11 flex items-center">
//       <div className="flex items-center whitespace-nowrap animate-marquee">
//         {items.map((item, index) => (
//           <React.Fragment key={index}>
//             <span className="text-[9px] tracking-[4px] uppercase text-[#9a9a9a] px-7">
//               {item}
//             </span>
//             <span className="text-[#c9a96e] px-2 text-sm">·</span>
//           </React.Fragment>
//         ))}
//         {items.map((item, index) => (
//           <React.Fragment key={`dup-${index}`}>
//             <span className="text-[9px] tracking-[4px] uppercase text-[#9a9a9a] px-7">
//               {item}
//             </span>
//             <span className="text-[#c9a96e] px-2 text-sm">·</span>
//           </React.Fragment>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default Band;


import React from 'react';

const Band: React.FC = () => {
  const items = [
    'Mode Masculine',
    'Qualité Premium',
    'Style Intemporel',
    'Élégance Moderne',
    'Savoir-Faire',
    'Collections Exclusives',
  ];

  return (
    <div className="bg-[#111111] border-y border-[#333333] overflow-hidden h-11 sm:h-12 md:h-14 flex items-center">
      <div className="flex items-center whitespace-nowrap animate-marquee">
        {items.map((item, index) => (
          <React.Fragment key={index}>
            <span className="text-[8px] sm:text-[9px] md:text-[10px] tracking-[2px] sm:tracking-[3px] md:tracking-[4px] uppercase text-[#9a9a9a] px-4 sm:px-5 md:px-7">
              {item}
            </span>
            <span className="text-[#c9a96e] px-1 sm:px-1.5 md:px-2 text-xs sm:text-sm">·</span>
          </React.Fragment>
        ))}
        {/* Deuxième passe pour l'effet infini */}
        {items.map((item, index) => (
          <React.Fragment key={`dup-${index}`}>
            <span className="text-[8px] sm:text-[9px] md:text-[10px] tracking-[2px] sm:tracking-[3px] md:tracking-[4px] uppercase text-[#9a9a9a] px-4 sm:px-5 md:px-7">
              {item}
            </span>
            <span className="text-[#c9a96e] px-1 sm:px-1.5 md:px-2 text-xs sm:text-sm">·</span>
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default Band;